import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/tokens.css';
import './styles/base.css';
import { appliquerPreferences } from './lib/preferences.ts';
import { enregistrerServiceWorker } from './lib/horsLigne.ts';
import { ErreurApi } from './lib/api.ts';
import { Application } from './app/Application.tsx';

appliquerPreferences();
enregistrerServiceWorker();
const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Pas de nouvelle tentative inutile : droits, absence, ou hors connexion (le message s'affiche tout de suite).
      retry: (n, e) => !(e instanceof ErreurApi && ([401, 403, 404].includes(e.status) || e.code === 'hors_connexion')) && navigator.onLine && n < 2,
      refetchOnWindowFocus: false,
      // Hors connexion : la requête part quand même une fois (le service de l'application répond avec ce qui a été gardé sur le
      // téléphone, ou « hors connexion ») au lieu de rester en attente indéfiniment.
      networkMode: 'offlineFirst',
    },
  },
});

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <Application />
    </QueryClientProvider>
  </StrictMode>,
);
